import StarIcon from '@mui/icons-material/Star';
import { Box, Typography } from '@mui/material';

import TableDateCell from '../../../../../../shared/components/table-cells/TableDateCell/TableDateCell';
import { Alignments } from '../../../../../../shared/components/ui/Table/enums/alignments.enum';
import { TableColumnDef } from '../../../../../../shared/components/ui/Table/models/table-column.model';
import { castTo } from '../../../../../../shared/utils/cast-to';
import { ReviewModel } from '../../../models/review.model';
import { ReplyOnReview } from '../components/table-cells/reply-on-review/reply-on-review';

export const reviewsTableColumnDefUtil: TableColumnDef[] = [
  {
    field: 'date',
    headerName: 'Date',
    alignment: Alignments.LEFT,
    width: '9.32%',
    valueGetter: row => {
      return (
        <TableDateCell
          date={castTo<ReviewModel>(row).creationDate}
        ></TableDateCell>
      );
    },
  },
  {
    field: 'user',
    headerName: <Box sx={{ mx: '24px' }}>User</Box>,
    alignment: Alignments.LEFT,
    width: '10.05%',
    valueGetter: row => (
      <Box sx={{ mx: '20px' }}>{castTo<ReviewModel>(row).author}</Box>
    ),
  },
  {
    field: 'vehicle',
    headerName: <Box sx={{ mx: '24px' }}>Vehicle</Box>,
    alignment: Alignments.LEFT,
    width: '11.68%',
    valueGetter: row => (
      <Box sx={{ mx: '20px' }}>{castTo<ReviewModel>(row).vehicle}</Box>
    ),
  },
  {
    field: 'rating',
    headerName: 'Rating',
    alignment: Alignments.LEFT,
    width: '8.43%',
    valueGetter: row => (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography sx={{ mr: '4px' }}>
          {castTo<ReviewModel>(row).rating}
        </Typography>
        <StarIcon color="primary" />
      </Box>
    ),
  },
  {
    field: 'review',
    headerName: 'Review',
    alignment: Alignments.LEFT,
    width: '38.53%',
    valueGetter: row => (
      <ReplyOnReview
        review={castTo<ReviewModel>(row)}
        key={castTo<ReviewModel>(row).id}
      />
    ),
  },
  {
    field: 'release',
    headerName: 'Release',
    alignment: Alignments.LEFT,
    width: '9.59%',
    valueGetter: row => castTo<ReviewModel>(row).release,
  },
  {
    field: 'platform',
    headerName: 'Platform',
    alignment: Alignments.RIGHT,
    width: '10.39%',
    valueGetter: row => castTo<ReviewModel>(row).platform,
  },
];
